import styled from 'styled-components'
import { Hr } from 'ui/components'

export const WrappedHr = styled(Hr)`
  margin-bottom: 21px;
`

export const License = styled.div`
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 20px;
`
